<template>
    <infinite-pagination-table
        ref="table"
        :next="next"
        :headers="headers"
        :provider="provider"
        :page="page"
        :count-per-page="countPerPage"
        :theme="theme"
        :search="search"
        :hide-pagination="hidePagination"
        :full-load="fullLoad"
        :sort-desc="sortDesc"
        @click:row="item => $emit('click:row', item)"
        @update:filtered="v => $emit('update:filtered', v)"
        @update:checked="v => $emit('update:checked', v)"
        @update:items="v => $emit('update:items', v)"
    >
        <!-- 부모의 slot 을 그대로 자식 컴포넌트로 전달합니다 -->
        <template
            v-for="(index, name) in $scopedSlots"
            v-slot:[name]="data"
        >
            <slot
                :name="name"
                v-bind="data"
            />
        </template>
    </infinite-pagination-table>
</template>

<script>
import InfinitePaginationTable
    from "../infinite-pagination-component-table/InfinitePaginationTable";

/**
 * 데이터 테이블입니다.
 *
 * order, filter, infinite paging, item slot, keyboard action(esc, key arrow, tab, enter) 키 등을 지원합니다.
 */
export default {
    name: "MpsDataTable",
    components: {InfinitePaginationTable},
    props: {
        /** item 에 대한 속성을 정의합니다. */
        headers: {
            type: Array,
            default: () => [],
        },
        /** 현재 페이지입니다. */
        page: {
            type: Number,
            default: 1
        },
        /** 한 페이지당 출력할 아이템수 입니다. */
        countPerPage: {
            type: Number,
            default: 15
        },
        /** pageNumber 와 pageSize 로 데이터를 반환하는 콜백함수 */
        next: {
            type: Function,
            // (pageNumber, pageSize) => {},
            default: undefined,
        },
        /** 어떤 form 을 사용할지 결정합니다. */
        provider: {type: String, default: 'mps'},
        /** 어떤 테마를 적용할지 결정합니다. */
        theme: {type: String, default: undefined},
        /** 검색 키워드 입니다. */
        search: {
            type: String,
            default: undefined,
        },
        /** 페이지네이션은 하되 페이지네이션 영역을 보이지 않게 숨깁니다. */
        hidePagination: {
            type: Boolean,
            default: false,
        },
        /** 한 번에 모든 데이터를 로드합니다. 이 값이 true 이면 페이지네이션 영역은 숨겨집니다. */
        fullLoad: {
            type: Boolean,
            default: false,
        },
        /** true 이면 sort 시 desc 로 먼저 sorting 합니다. */
        sortDesc: {
            type: Boolean,
            default: true,
        },
    },
    methods: {
        clearAndNext() {
            this.$refs.table && this.$refs.table.clearAndNext();
        },
    }
}
</script>

<style scoped>

</style>